import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Ny sida ska börja högst upp – utom när en ankarlänk pekar in i sidan. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);

  return null;
}
